<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Données d'accidentologie en attente d'approbation</h2>

        <b-col cols="10">
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-marches"
                                  :label=libelles.marche label-for="input-marches"
                                  label-class="typo-required-field" v-if="isAdmin">
                        <b-form-select
                                id="input-marches"
                                v-model="marcheId"
                                :options="marches"
                                required>
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                     {{libelles.selectionnerMarche}}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

        </b-col>

        <div v-if="securiteChantiersResult">
            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="securiteChantiersResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="securiteChantiersTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                        </div>
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="consulterSecuriteChantiers(row.item.id)">
                            <Icon icon="book-open" size="1x"></Icon>
                        </b-button>
                    </template>
                    <template v-slot:cell(validate)="row">
                        <b-button size="sm" v-b-modal="'modal-validate' + row.item.id">
                            <Icon icon="check-square" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-validate' + row.item.id"
                                title="Approbation de données d'accidentologie"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="validerSecuriteChantiers(row.item)">
                            <p v-if="row.item.statut === 'ATTENTE_MODIFICATION'">{{libelles.confirmationSuppression}}</p>
                            <p v-if="row.item.statut === 'ATTENTE_SUPPRESSION'">{{libelles.confirmationSuppression}}</p>
                        </b-modal>
                    </template>
                  <template v-slot:cell(reject)="row">
                    <b-button size="sm" @click="onClickReject(row.item.id)">
                      <Icon icon="times" size="1x"></Icon>
                    </b-button>
                  </template>
                </b-table>
            </div>
        </div>
      <reject-modal @ok="reject"></reject-modal>
    </div>
</template>

<script>

  import MarcheSecuriteChantiersStore from "../../stores/MarcheSecuriteChantiersStore";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import MarcheSecuriteChantiersDto from "../../dtos/MarcheSecuriteChantiersDto";
  import {StatutEnum} from "../../constants/enums";
  import moment from 'moment';
  import {libelles} from '../../constants/libelles';
  import hasPermission from "../../filters/hasPermission";
  import {EventBus} from '@/event-bus'
  import SessionStore from '@/stores/SessionStore'
  import RejectModal from "@/components/RejectModal.vue";

  export default {
    components: {RejectModal},
    data() {
      return {
        marcheId: null,
        marches: [],
        securiteChantiersResult: null,
        selectedSecuriteChantier: null,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        libelles: libelles,
        sessionStoreState: SessionStore.state,
      }
    },
    computed: {
      isAdmin() {
        return hasPermission(["ADMINISTRATEUR", "CORRESPONDANT_SECURITE_ADMINISTRATEUR"]) && !this.sessionStoreState.marches.length;
      },
      fields() {
        const fields = [
          {label: '', key: 'num', sortable: false},
          {label: 'Date de dernière modification', key: 'modifiedDate', sortable: true},
          {label: 'Données pour le mois', key: 'date', sortable: true},
          {label: 'Statut', key: 'statutLabel', sortable: false},
          {label: 'Consulter', key: 'edit', sortable: false},
          {label: 'Approuver', key: 'validate', sortable: false},
          {label: 'Rejeter', key: 'reject', sortable: false}
        ];
        if (!this.marcheId) {
          fields.splice(1, 0, {label: 'Marché', key: 'marche', sortable: true})
        }
        return fields
      },
      securiteChantiersTable: function () {
        return this.securiteChantiersResult.content.map(securiteChantiers => {
          return {
            id: securiteChantiers.id,
            date: moment(securiteChantiers.date).format('MM/YYYY'),
            marche: `${securiteChantiers.marche.reference} (${securiteChantiers.marche.libelleCourt})`,
            statut: securiteChantiers.statut,
            statutLabel: StatutEnum[securiteChantiers.statut],
            modifiedDate: new Date(securiteChantiers.modifiedDate).toLocaleDateString(),
          }
        });
      }
    },
    watch: {
      marcheId() {
        this.search();
      },
    },
    mounted() {
      this.initPagination();
      if (this.isAdmin) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
          });
        });
        this.search();
      } else {
        this.marcheId = this.sessionStoreState.marche.id;
        EventBus.$on('NavBar-marcheChange', () => {
          this.marcheId = this.sessionStoreState.marche.id;
        });
      }
    },
    beforeDestroy() {
      if (!this.isAdmin) {
        EventBus.$off('NavBar-marcheChange');
      }
    },
    methods: {
      onClickReject(id) {
        this.$bvModal.show('modal-reject')
        this.selectedSecuriteChantier = id
      },
      reject(event) {
        MarcheSecuriteChantiersStore
          .reject(this.selectedSecuriteChantier, event.comment)
          .then(() => {
            this.search()
          })
      },
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sortOptions = [{sortBy: 'marche', sortDirection: 'asc'}];
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      consulterSecuriteChantiers(id) {
        this.$router.push("/marche-securite-chantiers/" + id);
      },
      validerSecuriteChantiers(securiteChantiers) {
        MarcheSecuriteChantiersStore.validate(securiteChantiers).then(() => {
          this.search();
        });
      },
      search() {
        const securiteChantiers = new MarcheSecuriteChantiersDto();
        securiteChantiers.marche = this.marcheId;
        securiteChantiers.statut = ['ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION'];
        MarcheSecuriteChantiersStore.search(securiteChantiers, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.securiteChantiersResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      }
    }
  }
</script>

